import * as actions from './actions';
import * as cmxKeys from './cmxKeys';
import * as selectors from './selectors';

// export { GamesDispatch } from './actions';
export { games } from './reducer';
// export { ArcadeInfo, ArcadeView, CabinetEntryView, CabinetView, GamesAppState, RoomView } from './types';
export const Games = { ...actions, cmxKeys, ...selectors };

// export function Games() {
//     return { ...actions, cmxKeys, ...selectors };
// }
